import React from 'react';
import { domain } from '../common/config.js';
let Logo = "//" + domain + "/images/common/loadingNew.gif"

class Loading extends React.Component {
   render() {
      return (
         <div className="app-content-loading">
            {/* <div className='row' style={{
               backgroundColor: "#ffffff", position: "fixed", width: "150px", height: "150px", top: "50%", left: "50%", marginTop: "-100px"
               , marginLeft: "-75px"
            }}> */}
            <div className='loadingImage'>
            <img id="loadingImg" height="60px" className="loading-spinner" src={Logo} alt="Loading..." />
               <div className='loadingTitle'> Loading</div>
            </div>
         </div>
      );
   }
}

export default Loading;



/** WEBPACK FOOTER **
 ** ./src/components/Loading.js
 **/